import CashierServiceModel from "../CashierServiceModel";
import InvoiceCollection from "../../collections/cashier/InvoiceCollection";
import CustomerContactCollection from "../../collections/cashier/CustomerContactCollection";

export default class CustomerModel extends CashierServiceModel {

  modelName() {
    return 'customers';
  }

  defaults() {
    return {
      id: null,
      name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer_contacts: [],
      invoices: []
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getCustomerContacts() {
    return this.getRelatedCollection(new CustomerContactCollection(), 'customer_contacts');
  }

  getInvoices() {
    return this.getRelatedCollection(new InvoiceCollection(), 'invoices');
  }

}
